import dayjs from 'dayjs'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'
import { DATE_TIME_FORMAT } from 'utils/constants/datetime'
import { formatPhone } from 'utils/helper/common-helpers'
import type { QrConfirmReservationData } from './types'

type ScanCheckInSuccessPanelProps = {
  data: QrConfirmReservationData
  onClose: () => void
}

export function ScanCheckInSuccessPanel({
  data,
  onClose,
}: ScanCheckInSuccessPanelProps) {
  const { t } = useTranslation()

  const timeslotLabel =
    data.timeslotStart && data.timeslotEnd
      ? `${dayjs(data.timeslotStart).format(DATE_TIME_FORMAT.HOUR)} - ${dayjs(data.timeslotEnd).format(DATE_TIME_FORMAT.HOUR)}`
      : undefined

  return (
    <div className="scan-qr-confirm scan-qr-confirm--page">
      <div className="scan-qr-confirm__panel scan-qr-confirm__panel--page border-round-xl p-3 w-full">
        <div className="scan-qr-confirm__panel-scroll">
          <div className="flex flex-column align-items-center text-center">
            <div className="flex align-items-center gap-2">
              <div
                className="w-2rem h-2rem scan-qr-heading-icon scan-qr-heading-icon--success flex align-items-center justify-content-center border-circle"
                aria-hidden
              >
                <i className="isax-tick-circle text-white scan-qr-heading-icon__glyph" />
              </div>
              <h3 className="m-0 text-lg font-bold text-white line-height-3">
                {t('Check-in successful')}
              </h3>
            </div>
          </div>

          <div className="scan-qr-confirm__card border-round-xl p-4 mt-3">
            <div className="mb-0">
              <div className="scan-qr-confirm__card-label mb-1">{t('Name')}</div>
              <div className="scan-qr-confirm__card-name">{data.name}</div>
              {data.furigana ? (
                <div className="scan-qr-confirm__card-furigana mt-1">
                  {data.furigana}
                </div>
              ) : null}
            </div>

            <div className="scan-qr-confirm__card-divider" />

            <div className="scan-qr-confirm__meta-row flex gap-4">
              {timeslotLabel ? (
                <div className="flex-1 min-w-0">
                  <div className="scan-qr-confirm__card-label mb-1">
                    {t('Time slot')}
                  </div>
                  <div className="scan-qr-confirm__card-value white-space-normal">
                    {timeslotLabel}
                  </div>
                </div>
              ) : null}
              <div className="flex-1 min-w-0">
                <div className="scan-qr-confirm__card-label mb-1">
                  {t('Registrations')}
                </div>
                <div className="scan-qr-confirm__card-value">
                  {data.guestCount} {t('guest(s)')}
                </div>
              </div>
            </div>

            <div className="scan-qr-confirm__card-divider" />

            <div className="mb-3">
              <div className="scan-qr-confirm__card-label mb-1">{t('Email')}</div>
              <div className="scan-qr-confirm__card-value white-space-normal scan-qr-confirm__email-value">
                {data.email}
              </div>
            </div>
            <div>
              <div className="scan-qr-confirm__card-label mb-1">
                {t('Phone number')}
              </div>
              <div className="scan-qr-confirm__card-value">
                {formatPhone(data.phoneNumber)}
              </div>
            </div>
          </div>
        </div>

        <div className="scan-qr-confirm__panel-actions flex flex-column gap-3">
          <Button
            type="button"
            label={t('Scan Next')}
            className="scan-qr-reject__scan-next w-full font-bold"
            onClick={onClose}
          />
        </div>
      </div>
    </div>
  )
}
